import { render, staticRenderFns } from "./RseResearch.vue?vue&type=template&id=526bfba0&"
import script from "./RseResearch.vue?vue&type=script&lang=js&"
export * from "./RseResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports